<template>
  <div>
	<div class="data31">
		<div class="data31Til">便捷诊疗·得心应手</div>
		<div class="data31Box">
			<div class="data31BoxList" v-for="(item,index) in list" :key="index">
				<div class="data31BoxListImg">
					<img :src="item.img" />
				</div>
				<div class="data31BoxListImgTwo">
					<img :src="item.imgTwo" />
				</div>
				<div class="data31BoxListWz">
					<div class="data31BoxListWzName">
						{{item.name}}
					</div>
					<div class="data31BoxListWzCen">
						{{item.cen}}
					</div>
				</div>
			</div>
		</div>
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
    data() {
      return {
		list:[
			{
				img:require('@/assets/product/page8/ledgy.png'),
				imgTwo:require('@/assets/product/page11/dgcsj.png'),
				name:'大视场角',
				cen:'- 140°大视场角- 减少信息遗漏'
			},
			{
				img:require('@/assets/product/page8/ledgy.png'),
				imgTwo:require('@/assets/product/page11/dqd.png'),
				name:'大钳道',
				cen:'- 结肠镜钳道3.7mm- 可匹配绝大多数手术耗材'
			},
		]
      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data31{
	width: 1200px;
	margin: 0 auto;
	padding-bottom: 153px;
	.data31Til{
		font-size: 45px;
		font-family: Source Han Sans CN;
		font-weight: bold;
		color: #000000;
		margin-bottom: 73px;
	}
	.data31Box{
		display: flex;
		justify-content: space-between;
		.data31BoxList:not(:last-child){
			margin-right: 40px;
		}
		.data31BoxList:hover{
			.data31BoxListImg{
				img{
					transform: scale(1.1);
				}
			}
		}
		.data31BoxList{
			
			.data31BoxListImg{
				margin-bottom: 33px;
				width: 580px;
				height: 580px;
				overflow: hidden;
				margin-bottom: 40px;
				img{
					width: 580px;
					height: 580px;
					// object-fit: cover;
					transition: all 0.3s ease-in-out;
				}
			}
			.data31BoxListImgTwo{
				margin-bottom: 39px;
				img{
					width: 70px;
					height: 70px;
					// object-fit: cover;
					transition: all 0.3s ease-in-out;
				}
			}
			.data31BoxListWz{
				.data31BoxListWzName{
					margin-right: 20px;
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #000000;
					margin-bottom: 32px;
				}
				.data31BoxListWzCen{
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;
				}
			}
		}
	}
}
</style>
